import { sendBackendPagination } from "../../common/utils/pagination";
import ISyncLiquidityPoolsRequestDto from "../../interfaces/liquidity-pool/ISyncLiquidityPoolsRequestDto";
import ILiquidityPoolPagedResponseDto from "../../interfaces/liquidity-pool/ILiquidityPoolPagedResponseDto";
import { IPagination } from "../../interfaces/pagination/IPagination";
import { cryptoPortfolioService } from "../httpService/cryptoPorfolio.service";

export async function tryGetAllLiquidityPools(pagination: IPagination, showClosed: boolean) {
  return await cryptoPortfolioService.get<ILiquidityPoolPagedResponseDto>(
    `/liquiditypool/getall?page=${sendBackendPagination(pagination.page)}&pageSize=${pagination.rowsPerPage}&showClosed=${showClosed}`
  );
}

export async function trySyncLiquidityPools(request: ISyncLiquidityPoolsRequestDto) {
  return await cryptoPortfolioService.post('/liquiditypool/sync', request);
}
